// Module
var code = "<div ng-bind-html=\"parser.parsedMessage\"></div>";
// Exports
module.exports = code;